function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 22V5h6v5a1 1 0 001 1h5v11H2zm8-15.586L12.586 9H10V6.414zm5.598 2.77a.997.997 0 01.422.816c0 .035-.017.065-.02.099V22c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V5c0-1.103.897-2 2-2h7c.021 0 .039.011.061.012a1 1 0 01.265.054c.032.011.064.019.094.034.102.047.2.108.284.191l.004.003 5.89 5.89zM24.02 7c0 .035-.017.065-.02.099V19c0 1.103-.897 2-2 2h-4a1 1 0 010-2h4V8h-5a1 1 0 01-1-1V2H9a1 1 0 010-2h8c.022 0 .04.011.062.013a.96.96 0 01.264.053c.032.011.064.019.094.034.103.047.2.108.284.191l.004.003 5.89 5.89A.997.997 0 0124.02 7zM18 6h2.586L18 3.414V6z"
});

var SvgIconCopy = function SvgIconCopy(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconCopy;